import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayOPEEnum} from "./GatewayOPEEnum";

/**
 * O Inner Class
 */
class O {
  id!: number;
}

/**
 * I Inner Class
 */
class I {
  id?: number;
  partitionId!: number;
  name!: string;
  typeId!: number;
  sendingCron!: string;
  macAddress?: string;
}

/**
 * Writes reg_gateway directly, bypassing the pending-config draft (unlike putGateway).
 * Used for gateway creation: the gateway is FLASHED, so there is no config to keep in sync
 * with the edge and no asynchronism to handle.
 */
export class PutGatewayLegacyCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayOPEEnum.PutGatewayLegacy);
    this.i = new I();
    this.o = new O();
  }
}
